import applyDiscount from "../utils/applyDiscount";
import appValidationOptions from "../utils/validation/appValidationOptions";
import {registerAdditionalRules} from "../utils/validation/additionalValidationRules";

class Form {
    constructor($form) {
        this.$form = this.prepareForm($form)
        this.validator = this.createValidator()
        this.registerEventListeners()
        this.onFormInit();
    }

    onFormInit() {
        while (this.hasUnansweredSections() && this.isValid()) {
            this.showNextSection();
        }
        this.onFormChange()
    }

    prepareForm($form) {
        this.prepareFormSections($form)
        return $form
    }

    createValidator() {
        const generalValidateOptions = {
            onclick: false,
            onfocusout: false,
            onkeyup: false,
        }
        return this.$form.validate({ ...generalValidateOptions, ...appValidationOptions})
    }

    registerEventListeners() {
        this.$form.on('input', ':input', (e) => this.onInput(e))
        this.$form.on('form:add-error', (event, error) => {
            console.debug(event, error)
            // TODO implement, needed for email ajax validation
        })
        this.$form.on('form:change', (event) => this.onFormChange())
    }

    onInput(event) {
        this.validator.element(event.target)
        this.onFormChange()
    }

    onFormChange() {
        applyDiscount()
        if (this.isValid() && !this.hasUnansweredSections()) {
            this.enableSubmitButton();
        } else {
            this.disableSubmitButton();
        }
        if (this.isValid() && this.hasUnansweredSections()) {
            this.showNextSection();
        }
    }

    isValid() {
        const hasErrors =  this.validator.numberOfInvalids() > 0
        const $requiredUnanswered = this.validator.elements()
            // optional is false if element is answered
            .filter((i, e) => $(e).rules().required === true && this.validator.optional(e) !== false);

        return !hasErrors && $requiredUnanswered.length === 0
    }

    enableSubmitButton() {
        const $button = this.$form.find('button[type="submit"]')
        $button.prop("disabled", false);
        $button.removeClass("btn--disabled");
    }

    disableSubmitButton() {
        const $button = this.$form.find('button[type="submit"]')
        $button.prop("disabled", true);
        $button.addClass("btn--disabled");
    }

    showNextSection() {
        const $nextSection = this.$form.find(".consolidated-section.disabled:first")
        $nextSection.removeClass('disabled')
        $nextSection.find(':input').attr("disabled", false);
    }

    hasUnansweredSections() {
        return this.$form.find('.consolidated-section.disabled').length > 0;
    }

    prepareFormSections($form) {
        // makes second and latter sections disabled
        const $sections = $form.find('.consolidated-section')
        for (let i = 1; i < $sections.length; i++) {
            const $section = $($sections[i])
            $section.addClass('disabled')
            $section.find(':input').attr('disabled', true)
        }
    }
}

$(document).ready(function () {
    const forms = document.getElementsByTagName('form');
    for (let i = 0; i < forms.length; i++) {
        new Form($(forms[i]));
    }
    if (forms.length > 0) {
        registerAdditionalRules()
    }
});
